<template>
  <v-dialog
    :value="show"
    max-width="500"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card class="confirmation-dialog" dark>
      <v-card-title class="confirmation-header">
        <v-icon color="white" class="mr-2">mdi-alert-circle</v-icon>
        <span class="confirmation-title">{{ title || 'Confirm Action' }}</span>
      </v-card-title>
      
      <v-card-text class="confirmation-content">
        <p class="confirmation-message">{{ message }}</p>
      </v-card-text>
      
      <v-card-actions class="confirmation-actions">
        <v-spacer />
        <v-btn
          outlined
          color="grey"
          @click="handleCancel"
          class="confirmation-btn"
          dark
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          dark
          @click="handleConfirm"
          class="confirmation-btn"
          elevation="2"
        >
          <v-icon left>mdi-check</v-icon>
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Confirm Action'
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },
    handleCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
.confirmation-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.confirmation-header {
  display: flex;
  align-items: center;
  padding: 1.5rem;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
}

.confirmation-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: white;
}

.confirmation-content {
  padding: 1.5rem;
  background: #1e293b;
}

.confirmation-message {
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  color: rgba(255, 255, 255, 0.87);
}

.confirmation-actions {
  padding: 1rem 1.5rem;
  background: #1e293b;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.confirmation-btn {
  margin-left: 8px;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 0.75rem 1.5rem;
  min-width: 120px;
  border-radius: 8px;
}
</style>

